import React from 'react';
import PropTypes from 'prop-types';
import Paragraph from '../../paragraph';
import { APPEARANCES } from '../../paragraph/constants';

const CheckboxDescription = ({ children, appearance = 'medium-emphasis' }) => (
  <div className="ws-ui-checkbox__description">
    <Paragraph size="small" appearance={appearance}>
      {children}
    </Paragraph>
  </div>
);

CheckboxDescription.propTypes = {
  children: PropTypes.node.isRequired,
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
};

export default CheckboxDescription;
